var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmailOpenPlusOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4672_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.202 11.8988L18.422 11.7488L20.202 10.5388V11.7488H21.702V9.77876C21.702 9.23876 21.412 8.76876 20.992 8.50876H20.982L18.202 6.01876V4.79876C18.202 3.96876 17.532 3.29876 16.702 3.29876H15.162L12.152 0.60876C11.592 0.12876 10.772 0.12876 10.192 0.61876L7.21198 3.29876H5.70197C4.87197 3.29876 4.20198 3.96876 4.20198 4.79876V6.00876L1.42198 8.50876C0.991975 8.76876 0.711975 9.23876 0.711975 9.77876V21.7388C0.711975 22.5688 1.38198 23.2388 2.21198 23.2388H10.842V21.7388H2.20198V10.5388L10.162 15.9488C10.362 16.0888 10.602 16.1688 10.842 16.2188C10.962 16.2388 11.082 16.2488 11.202 16.2488C11.572 16.2488 11.952 16.1488 12.242 15.9488L18.202 11.8988ZM18.212 8.03876L18.482 8.27876L19.512 9.19876L18.662 9.77876L18.212 10.0888V8.03876ZM4.20198 10.0888L3.75198 9.77876L2.89198 9.19876L3.91198 8.27876L4.20198 8.01876V10.0888ZM11.172 1.72876L12.922 3.28876H9.44197L11.172 1.72876ZM11.402 14.7088C11.312 14.7688 11.092 14.7688 11.002 14.7088L10.842 14.5988L5.70197 11.0988V4.78876H16.702V11.0988L15.752 11.7488L11.402 14.7088Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.262 18.4988H19.512V14.7488H18.012V18.4988H14.262V19.9988H18.012V23.7488H19.512V19.9988H23.262V18.4988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4672_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmailOpenPlusOptions);
export default __webpack_public_path__ + "static/media/ic-email-open-plus-options.a982e301dccff1b08ad9dc72d1788921.svg";
export { ForwardRef as ReactComponent };